import { render, staticRenderFns } from "./TableProductCheck.vue?vue&type=template&id=f0c7045e&scoped=true"
import script from "./TableProductCheck.vue?vue&type=script&lang=js"
export * from "./TableProductCheck.vue?vue&type=script&lang=js"
import style0 from "./TableProductCheck.vue?vue&type=style&index=0&id=f0c7045e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c7045e",
  null
  
)

export default component.exports